import React, { useContext } from "react";
import Flex from '@react-css/flex';
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import { StyledPartialInformacoesTs } from '../../styled-components/StyledPartialInformacoesTs.style';

export const PartialSeguradora = ({isFromProjetoInterno}) => {
    const { timesheet } = useContext(TimeSheetDetalhesContext);
    return (
        <StyledPartialInformacoesTs>
            <div className="card pl-0 pr-0">
                <div className="timesheet-more-infs col-sm-12">
                    <h5 className="title-row-info mb-4">
                        Seguradora &nbsp;
                        <span className="title-row-sub">
                            {timesheet.cliente.clienteNome}
                        </span>
                    </h5>
                </div>
                { isFromProjetoInterno ? '' : <span>
                    <Flex className="timesheet-more-infs">
                        <Flex.Item className="col-sm-4">
                            <span className="legend-info">Analista</span>
                            <p className="data-info pl-0"> {timesheet.sinistro.analista} </p>
                        </Flex.Item>
                        <Flex.Item className="col-sm-4">
                            <span className="legend-info">Apolice</span>
                            <p className="data-info pl-0">{timesheet.sinistro.numeroApolice}</p>
                        </Flex.Item>
                        <Flex.Item className="col-sm-4">
                            <span className="legend-info">Aviso</span>
                            <p className="data-info pl-0">{timesheet.sinistro.numeroAviso}</p>
                        </Flex.Item>
                    </Flex>
                    <Flex className="timesheet-more-infs">
                        <Flex.Item className="col-sm-4">
                            <span className="legend-info">Sinistro</span>
                            <p className="data-info mb-0 p-0">{timesheet.sinistro.numeroSinistro}</p>
                        </Flex.Item>
                        { timesheet.cliente?.clienteNome?.trim().toUpperCase() === 'ZURICH SANTANDER' ? 
                            <>
                                <Flex.Item className="col-sm-4">
                                    <span className="legend-info">Rector</span>
                                    <p className="data-info mb-0 p-0">{timesheet.sinistro?.rector}</p>
                                </Flex.Item>
                            </> 
                        : 
                            <>
                                <Flex.Item className="col-sm-4">
                                    <span className="legend-info">Nº Processo</span>
                                    <p className="data-info mb-0 p-0">{timesheet.sinistro?.numeroProcessoJudicial}</p>
                                </Flex.Item>
                                <Flex.Item className="col-sm-4">
                                    <span className="legend-info">ISJ</span>
                                    <p className="data-info mb-0 p-0">{timesheet.sinistro?.numeroISJ}</p>
                                </Flex.Item>
                            </>
                        }
                    </Flex>
                </span> }
            </div >
        </StyledPartialInformacoesTs>
    );
};
